var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelVk14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M7.49 9.681s.18-.02.273-.12c.085-.09.082-.262.082-.262s-.011-.802.36-.92c.368-.116.839.775 1.338 1.118.378.26.665.203.665.203l1.336-.019s.698-.043.367-.592c-.027-.045-.193-.407-.993-1.15-.838-.776-.725-.65.283-1.995.615-.819.86-1.319.783-1.533-.073-.204-.524-.15-.524-.15l-1.504.01s-.112-.016-.194.034a.4.4 0 0 0-.133.161s-.238.634-.555 1.172c-.67 1.137-.938 1.198-1.047 1.127-.255-.165-.191-.661-.191-1.014 0-1.102.167-1.561-.325-1.68-.164-.04-.284-.065-.702-.07-.537-.005-.99.002-1.248.128-.171.084-.303.27-.223.281.1.013.325.06.444.223.154.21.149.68.149.68s.088 1.298-.207 1.459c-.203.11-.48-.115-1.078-1.147-.305-.528-.536-1.112-.536-1.112s-.045-.11-.124-.168c-.097-.07-.231-.093-.231-.093l-1.43.01s-.214.005-.292.098c-.07.084-.006.255-.006.255s1.119 2.617 2.385 3.936c1.162 1.21 2.48 1.13 2.48 1.13z"
}))));
export default SvgChannelVk14;